// window.Bootstrap = require('bootstrap')

const styles = require('./sass/app.sass')










/* ============================ Slider ============================ */
/*
import Flickity from 'flickity'
require('flickity/dist/flickity.min.css')
// require('flickity-fade')

const el = document.querySelector('.main-slider')
if (el) {
  // setTimeout(() => {
  const slider = new Flickity(el, {
    wrapAround: true, // infinite
    // cellAlign: 'left',
    // contain: true,
    // autoPlay: 2000,
    // pauseAutoPlayOnHover: false,
    // imagesLoaded: true,
    fade: true,
  })
  // }, 500)
}
*/












/* =================== Set background to element style ================== */
document.querySelectorAll('[data-bg]').forEach(el => {
  const bg = el.getAttribute('data-bg')
  el.style.backgroundImage = `url("/${bg}")`
})







/* ======================================== Navbar ======================================== */

const navbar = document.querySelector('nav.navbar')

// handle click: navbar toggler open menu
navbar.querySelector('.navbar-toggler').addEventListener('click', e => {
  e.preventDefault()
  const nav = e.target.closest('nav')
  if (nav.classList.contains('is-visible')) {
    nav.classList.remove('is-visible')
  } else {
    nav.classList.add('is-visible')
  }
})















/* ============================= Scroll Top Button ============================= */

// create scroll-top element: <a href="#" id="scrollTop"></a>
const getScrollTopBtn = () => {
  let el = document.getElementById('scrollTop')
  if (!el) {

    // create el
    el = document.createElement('a')
    el.href = '#'
    el.setAttribute('id', 'scrollTop')
    document.body.append(el)

    // handle click: scroll to top
    el.addEventListener('click', e => {
      e.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })

  }

  return el
}

// find right margin of any inner container
const setScrollBtnRightOffset = () => {
  const rightOffset = 10

  const innerContainer = document.querySelector('footer .container-xxl')
  const rightPos =  parseInt( window.getComputedStyle(innerContainer).marginRight )
  getScrollTopBtn().style.right = (rightPos + rightOffset) + 'px' // set right edge position
}

// find right margin of any inner container
const setScrollBtnTopOffset = () => {
  const bottomOffset = 20

  const footerTopOffset = window.innerHeight - document.querySelector('footer').getBoundingClientRect().top - 45

  // if btn top offset < footer top
  if (footerTopOffset > 0) {
    getScrollTopBtn().style.bottom = (footerTopOffset + bottomOffset) + 'px'
  } else {
    getScrollTopBtn().style.bottom = bottomOffset + 'px'
  }

  // if window top offset > N
  if (window.scrollY > 700) {
    getScrollTopBtn().classList.add('is-visible')
  } else {
    getScrollTopBtn().classList.remove('is-visible')
  }
}

// set right position on start and mark as initialized (delay 2s)
document.addEventListener('DOMContentLoaded', e => {
  setTimeout(() => {
    setScrollBtnRightOffset()
    getScrollTopBtn().classList.add('is-initialized')
  }, 2000)
})

// handle scroll: show scroll btn when needed
window.addEventListener('scroll', e => {
  setScrollBtnTopOffset()
})

// handle resize: show scroll btn when needed
window.addEventListener('resize', e => {
  setScrollBtnTopOffset()
  setScrollBtnRightOffset()
})


























/* ======================================== Contact Form ======================================== */

import { Recaptcha } from './_recaptcha'


const form = document.querySelector('.contact-form form')
const dialogSuccess = document.querySelector('.contact-form dialog.success')
const dialogFailed = document.querySelector('.contact-form dialog.failed')

if (form) {


  // animate labels
  form.querySelectorAll('.form-control').forEach(el => {
    el.addEventListener('focus', e => {
      el.parentElement.classList.add('active')
    })
    el.addEventListener('blur', e => {
      if (el.value.trim() === '') {
        el.parentElement.classList.remove('active')
      }
    })
  })


  // get recaptcha params
  const urlPublicKey = form.getAttribute('data-url-key')

  const urlSubmit = form.getAttribute('data-url-submit')

  const onSuccess = res => dialogSuccess.setAttribute('open', 'true')

  const onCatch = err => {
    // validation error
    if (err.response?.status === 422) {
      const errors = err.response.data?.errors
      Object.keys(errors).map(key => {
        const errInput = form.querySelector(`[name=${key}]`)
        // mark input as error
        errInput.classList.add('is-invalid')
        // add error message
        errInput.parentElement.querySelector('.invalid-feedback').textContent = errors[key]
        errInput.addEventListener('change', e => errInput.classList.remove('is-invalid'))
      })
      return
    }
    // unknown error
    dialogFailed.show()
  }

  Recaptcha({ form, urlPublicKey, urlSubmit, onSuccess, onCatch })

}



